$(document).ready(() => {

    $.extend(Tipped.Behaviors, {
        'custom-slow': {
            fadeIn: 600,
            fadeOut: 600
        }
    });

    Tipped.create('.tooltip-glosary', function(element) {
        return {
            title: $(element).data('title'),
            content: $(element).data('content')
        };
    }, {
            behavior: 'custom-slow',
            close: true,
            hideOn: false,
            hideOnClickOutside: true,
            maxWidth: 200,
            position: 'topright',
            showOn: 'click hover',
            skin: 'light',
            zIndex: 20,
            afterHide: function (content, element) {
                $(element).removeClass('highlight');
            },
            onShow: function(content, element) {
                $(element).addClass('highlight');
            }
    });

});
